class SubmitPromoCodeService {
  constructor(rest) {
    this.rest = rest;
  }

  request(promoCode) {
    const url = `/api/voucher-management/v1/public/vouchers/${promoCode}`;
    return this.rest({
      method: 'GET',
      path: url
    }).then((response) => {
      if (response.status.code === 200) {
        return response.entity;
      }
      return {};
    }, response => response);
  }
}

export default SubmitPromoCodeService;



/** WEBPACK FOOTER **
 ** ./src/services/SubmitPromoCodeService.js
 **/